// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"b7922d6b","732":"d5c95b61","977":"852174f5"}[chunkId] + ".chunk.js");